<template>
  <div class="text-sm text-gray-500 mt-1">
    <slot/>
  </div>
</template>
